module.exports = __webpack_public_path__ + "img/crop2.d03f8b0a.png";